<template>
  <v-alert
    color="primario"
    outlined
    dense
    class="perfis-info-alert mb-4"
    icon="fas fa-info-circle"
  >
    <slot />
  </v-alert>
</template>

<script>
export default {
  name: "PerfisInfoAlert"
};
</script>

<style scoped>
.perfis-info-alert {
  font-size: 13px;
  line-height: 1.5;
  border-radius: 14px !important;
  border-left-width: 5px !important;
  border-left-style: solid !important;
  border-left-color: var(--primary-color, #1976d2) !important;
}
.perfis-info-alert ::v-deep .v-alert__wrapper {
  align-items: flex-start;
}
.perfis-info-alert ::v-deep .v-alert__icon {
  align-self: flex-start;
  margin-top: 2px;
}
</style>
